import Vue from 'vue'
import Router from 'vue-router'
import wx from 'weixin-js-sdk';
import Index from '@/views/Index'
import Global from '@/assets/js/Global'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      meta:{
        index:0,
        title:'',
        needShare:false
      },
      component: Index,
    },
    /*{
      path: '/login.html',
      name: 'Login',
      meta:{
        index:0,
        title:'',
        needShare:false
      },
      component:() => import('@/views/Login')
    },
    {
      path: '/upload.html',
      name: 'Upload',
      meta:{
        index:0,
        title:'',
        needShare:false,
        tabbar:1
      },
      component:() => import('@/views/Upload')
    },
    {
      path: '/rule.html',
      name: 'Rule',
      meta:{
        index:0,
        title:'',
        needShare:false,
        tabbar:1
      },
      component:() => import('@/views/Rule')
    },
    {
      path: '/center.html',
      name: 'Center',
      meta:{
        index:0,
        title:'',
        needShare:false,
        tabbar:1
      },
      component:() => import('@/views/Center')
    },*/

    {
      path: '/10663/index.html',
      name: 'Index',
      meta:{
        index:0,
        title:'',
        needShare:false,
        v_url:'10663/'
      },
      component:() => import('@/views/test/Index')
    },
    {
      path: '/10663/login.html',
      name: 'Login',
      meta:{
        index:0,
        title:'',
        needShare:false,
        v_url:'10663/'
      },
      component:() => import('@/views/test/Login')
    },
    {
      path: '/10663/upload.html',
      name: 'Upload',
      meta:{
        index:0,
        title:'',
        needShare:false,
        tabbar:1,
        v_url:'10663/'
      },
      component:() => import('@/views/test/Upload')
    },
    {
      path: '/10663/rule.html',
      name: 'Rule',
      meta:{
        index:0,
        title:'',
        needShare:false,
        tabbar:1,
        v_url:'10663/'
      },
      component:() => import('@/views/test/Rule')
    },
    {
      path: '/10663/center.html',
      name: 'Center',
      meta:{
        index:0,
        title:'',
        needShare:false,
        tabbar:1,
        v_url:'10663/'
      },
      component:() => import('@/views/test/Center')
    },

    {
      path: '/10664/index.html',
      name: 'Index',
      meta:{
        index:0,
        title:'',
        needShare:false,
        v_url:'10664/'
      },
      component:() => import('@/views/test/Index')
    },
    {
      path: '/10664/login.html',
      name: 'Login',
      meta:{
        index:0,
        title:'',
        needShare:false,
        v_url:'10664/'
      },
      component:() => import('@/views/test/Login')
    },
    {
      path: '/10664/upload.html',
      name: 'Upload',
      meta:{
        index:0,
        title:'',
        needShare:false,
        tabbar:1,
        v_url:'10664/'
      },
      component:() => import('@/views/test/Upload')
    },
    {
      path: '/10664/rule.html',
      name: 'Rule',
      meta:{
        index:0,
        title:'',
        needShare:false,
        tabbar:1,
        v_url:'10664/'
      },
      component:() => import('@/views/test/Rule')
    },
    {
      path: '/10664/center.html',
      name: 'Center',
      meta:{
        index:0,
        title:'',
        needShare:false,
        tabbar:1,
        v_url:'10664/'
      },
      component:() => import('@/views/test/Center')
    },



    {
      path: '/10665/index.html',
      name: 'Index',
      meta:{
        index:0,
        title:'',
        needShare:false,
        v_url:'10665/'
      },
      component:() => import('@/views/test/Index')
    },
    {
      path: '/10665/login.html',
      name: 'Login',
      meta:{
        index:0,
        title:'',
        needShare:false,
        v_url:'10665/'
      },
      component:() => import('@/views/test/Login')
    },
    {
      path: '/10665/upload.html',
      name: 'Upload',
      meta:{
        index:0,
        title:'',
        needShare:false,
        tabbar:1,
        v_url:'10665/'
      },
      component:() => import('@/views/test/Upload')
    },
    {
      path: '/10665/rule.html',
      name: 'Rule',
      meta:{
        index:0,
        title:'',
        needShare:false,
        tabbar:1,
        v_url:'10665/'
      },
      component:() => import('@/views/test/Rule')
    },
    {
      path: '/10665/center.html',
      name: 'Center',
      meta:{
        index:0,
        title:'',
        needShare:false,
        tabbar:1,
        v_url:'10665/'
      },
      component:() => import('@/views/test/Center')
    },




    {
      path: "*", // 此处需特别注意置于最底部
      redirect: "/"
    }
  ]
});
router.beforeEach((to, from, next) => {
  //用你的方式获取登录的用户信息
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta.v_url) {
    /*console.log(Global);*/
    Global.api_base=Global.url_base+to.meta.v_url+"api/";
  }else{
    Global.api_base=Global.url_base+"api/";
  }

  next()
})
router.afterEach((to,form)=>{
  setTimeout(function (){
    /*document.querySelector('#app').scrollTo(0, 0);*/
    window.scrollTo(0, 0);
  },200);
  /*wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
    wx.showMenuItems({
      menuList: [
        'menuItem:share:appMessage',
        'menuItem:share:timeline'
      ]
    });
    wx.updateAppMessageShareData({
      title: '致敬热血 为爱奔跑', // 分享标题
      desc: '2023无偿献血健康公益跑', // 分享描述
      link: 'http://rexue.fengtusports.cn/', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: 'http://rexue.fengtusports.cn/images/share_img.jpg', // 分享图标
      success: function () {
        // 设置成功
      }
    });
    wx.updateTimelineShareData({
      title: '“致敬热血 为爱奔跑”—— 2023无偿献血健康公益跑', // 分享标题
      link: 'http://rexue.fengtusports.cn/', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: 'http://rexue.fengtusports.cn/images/share_img.jpg', // 分享图标
      success: function () {
        // 设置成功
      }
    });
  });*/
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js